import { atom } from 'recoil';

export default atom({
  key: 'notesPerLineState',
  default: 4,
});
